import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Table, FormControl } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CustomPagination from '../../CustomPagination';
import CurrencyConverter from '../../CurrencyConverter';
import Loader from '../../../components/Common/Loader';
import Link from '../../Link/Link';

import messages from '../../../locale/messages';
import debounce from '../../../helpers/debounce';
import { updatePayoutStatus } from '../../../actions/siteadmin/Payout/updatePayout';
import { updateCashPayout } from '../../../actions/siteadmin/Payout/updateCashPayout';
import { capitalizeFirstLetter } from '../../../helpers/capitalizeFirst';
import { demoRestrictionEncode } from '../../../actions/demoRestriction';
import { censorEmail, censorWord, decode } from '../../../helpers/queryEncryption';

import showToaster from '../../../helpers/toastrMessgaes/showToaster';

import { ExportCsvIcon } from '../../Common/Assets/SVGIcon/CommonSvgIcon';
import bt from '../../../components/commonStyle.css';
import s from './AutoPayout.css';
export class AutoPayoutList extends Component {
	static propTypes = {
		getPayoutData: PropTypes.object,
		updatePayoutStatus: PropTypes.any.isRequired,
	}
	constructor(props) {
		super(props)
		this.state = {
			currentPage: 1,
			isRestrict: false,
		}
	}

	async componentDidMount() {
		const { demoRestrictionEncode } = this.props;
		const isRestrict = await demoRestrictionEncode({});
		this.setState({ isRestrict });
	}

	handleKeywordSearch = debounce((searchList) => {
		const { getPayoutData: { refetch } } = this.props
		let variables = {
			currentPage: 1,
			searchList: searchList
		}
		this.setState(variables)
		refetch(variables)
	}, 250);

	paginationData = (currentPage) => {
		const { getPayoutData: { refetch } } = this.props;
		let variables = { currentPage };
		this.setState({ currentPage });
		refetch(variables);
	}

	cashPayout = (id, value, currentPage) => {
		const { updateCashPayout, getPayoutData: { refetch } } = this.props;
		let payoutStatus = value == 'true' ? true : false;
		updateCashPayout(id, payoutStatus, currentPage)
		let variables = { currentPage };
		this.setState({ currentPage });
		refetch(variables);
	}

	holdPayout = (e, id, currentPage) => {
		const { updatePayoutStatus, getPayoutData: { refetch } } = this.props;
		let isBanStatus = (e.target.value);
		if (isBanStatus == "true" || isBanStatus == "false") {
			isBanStatus = (isBanStatus == "true") ? true : false;
			updatePayoutStatus(id, isBanStatus);
		}
		let variables = { currentPage };
		this.setState({ currentPage });
		refetch(variables);
	}

	restrictExport = () => {
		showToaster({ messageId: 'disableDemo', toasterType: 'warning' })
	};

	render() {
		const { getPayoutData, getPayoutData: { loading } } = this.props;
		const { formatMessage } = this.props.intl;
		const { currentPage, searchList, isRestrict } = this.state;

		return (
			<div className={'whiteDropdown'}>
				<div className={s.exportDisplay}>
					<div className={s.searchGroupContainer}>
						<div className={cx(s.searchInput, 'searchInputRTL')}>
							<FormControl type='text' placeholder={formatMessage(messages.searchOnly)} onChange={(e) => this.handleKeywordSearch(e.target && e.target.value)} className={bt.formControlInput} />
						</div>
					</div>
					<div className={cx(s.exportTextSection)}>
						{
							getPayoutData?.getPayoutList?.results && getPayoutData?.getPayoutList?.results?.length > 0 && (isRestrict ? <a
								href={"#"} className={cx(s.exportTextContainer)} onClick={() => this.restrictExport()}>
								<span className={cx(s.vtrMiddle, s.exportText, 'exportTextRTL')}><FormattedMessage {...messages.exportDataIntoCSV} /></span>
								<span className={cx(s.vtrTextBottom)}>
									<ExportCsvIcon />
								</span>
							</a> : <a
								href={`/export-admin-data?type=payout&keyword=${searchList ? searchList : ''}`}
								className={cx(s.exportTextContainer)}>
								<span className={cx(s.vtrMiddle, s.exportText, 'exportTextRTL')}><FormattedMessage {...messages.exportDataIntoCSV} /></span>
								<span className={cx(s.vtrTextBottom)}>
									<ExportCsvIcon />
								</span>
							</a>)
						}
					</div>
				</div>
				{
					loading && <div>
						<Loader type="circle" />
					</div>
				}
				{!loading &&
					<div className='tableOuterContainer'>
						<Table className="tableContainer">
							<thead>
								<tr>
									<th scope="col"><FormattedMessage {...messages.id} /></th>
									<th scope="col"><FormattedMessage {...messages.partnerName} /></th>
									<th scope="col"><FormattedMessage {...messages.email} /></th>
									<th scope="col"><FormattedMessage {...messages.payoutAmount} /></th>
									<th scope="col"><FormattedMessage {...messages.payoutStatus} /></th>
									<th scope="col"><FormattedMessage {...messages.action} /></th>
									<th scope="col"><FormattedMessage {...messages.holdPayout} /></th>
									<th scope="col"><FormattedMessage {...messages.details} /></th>
								</tr>
							</thead>
							<tbody>
								{
									getPayoutData?.getPayoutList?.results && getPayoutData?.getPayoutList?.results?.length > 0 && getPayoutData?.getPayoutList?.results?.map((item, index) => {
										return (
											<tr key={index}>
												<td data-label={formatMessage(messages.id)}>{item?.id}</td>
												<td data-label={formatMessage(messages.partnerName)}>{item && item?.partnerDetails && capitalizeFirstLetter(isRestrict ? censorWord(decode(item?.partnerDetails.encryptFirstName)) : decode(item?.partnerDetails.encryptFirstName))}</td>
												<td data-label={formatMessage(messages.email)}>
													{item?.partnerDetails?.userData && (isRestrict ? censorEmail(decode(item?.partnerDetails?.userData?.encryptEmail)) : decode(item?.partnerDetails?.userData?.encryptEmail))}
												</td>
												<td data-label={formatMessage(messages.payoutAmount)}><CurrencyConverter from={item?.currency} amount={item?.partnerTotalFare} /></td>
												<td data-label={formatMessage(messages.payoutStatus)}>{(item?.paymentType === 1) ? formatMessage(messages['processedCash']) : (item?.isPayoutPaid && item?.isPayoutPaid == true) ? formatMessage(messages['completed']) : formatMessage(messages['pending'])}</td>
												<td data-label={formatMessage(messages.action)}>{(item?.paymentType === 1) ? (
													<div>
														<select value={item?.isPayoutPaid} onChange={(e) => { this.cashPayout(item?.id, e.target.value, currentPage) }} className={bt.selectInput}>
															<option value={true}>{formatMessage(messages.paid)}</option>
															<option value={false}>{formatMessage(messages.unpaid)}</option>
														</select>
													</div>
												) : formatMessage(messages.notRequiredMessage)}</td>
												{item.isPayoutPaid == '1' ? <td data-label={formatMessage(messages.holdPayout)}>{formatMessage(messages.notRequiredMessage)}</td> :
													<td data-label={formatMessage(messages.holdPayout)}>
														<div>
															<select value={item.isBanStatus} onChange={(e) => { this.holdPayout(e, item.id, currentPage) }} className={bt.selectInput}>
																<option value={true}>{formatMessage(messages.yes)}</option>
																<option value={false}>{formatMessage(messages.no)}</option>
															</select>
														</div>
													</td>
												}
												<td data-label={formatMessage(messages.details)}>
													<div>
														<Link to={'/siteadmin/payout/view/' + item.id} className="actionLinkText"><FormattedMessage {...messages.viewJob} /></Link>
													</div>
												</td>
											</tr>
										)
									})
								}
								{
									!loading && getPayoutData?.getPayoutList?.results && getPayoutData?.getPayoutList?.results?.length == 0 && (
										<tr>
											<td colspan="12" className={'tableNoRecordCel'}><FormattedMessage {...messages.noResult} /></td>
										</tr>
									)
								}
							</tbody>
						</Table>
					</div>
				}
				{
					getPayoutData?.getPayoutList?.results && getPayoutData?.getPayoutList?.results?.length > 0
					&& <div className={cx(bt.space5, bt.spaceTop5)}>
						<CustomPagination
							total={getPayoutData.getPayoutList.count}
							currentPage={currentPage}
							defaultCurrent={1}
							defaultPageSize={10}
							change={this.paginationData}
							paginationLabel={formatMessage(messages.partnerPayout)}
						/>
					</div>
				}
			</div>
		)
	}
}

const mapDispatch = {
	updatePayoutStatus,
	updateCashPayout,
	demoRestrictionEncode
};

const mapState = (state) => ({});

export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(AutoPayoutList)));